import './TextArea.less'
import TextArea from './TextArea'
export type { TextAreaProps, TextAreaRef } from './iTextArea'
export default TextArea
